// extracted by mini-css-extract-plugin
export default {"formGroup":"SuggestionPopup_formGroup__GOdh1","formLabel":"SuggestionPopup_formLabel__9pCpS","formTextarea":"SuggestionPopup_formTextarea__5kYsv"};